// Shared Hunter UI tokens + small config maps.
// Light theme, matching the other global_admin pages (Escalations, Cron Health,
// Financials): gray-50 page, white cards, gray borders, colored pill badges.

export const card = 'bg-white border border-gray-200 rounded-xl';
export const input =
  'border border-gray-300 rounded-lg px-3 py-2 text-sm text-gray-800 ' +
  'placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-400';
export const btnPrimary =
  'inline-flex items-center justify-center gap-1.5 px-3.5 py-2 text-sm font-semibold text-white ' +
  'bg-indigo-600 hover:bg-indigo-700 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
export const btnGhost =
  'inline-flex items-center justify-center gap-1.5 px-3 py-2 text-sm font-medium text-gray-600 ' +
  'hover:bg-gray-100 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
export const btnDone =
  'inline-flex items-center justify-center gap-1.5 px-3.5 py-2 text-sm font-semibold text-white ' +
  'bg-green-600 hover:bg-green-700 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed';

export const CATEGORIES = ['Pain Point', 'Competitor', 'Buying Signal'];

// categoryPill still keys on the Keyword Library's 3 input categories (Pain
// Point/Competitor/Buying Signal phrases the Library manages, unchanged) --
// but a hit's OWN badges (cite-bait/engage) now come from hitBadge below, not
// this map, since a hit's category on hunter_signals is only ever 'Competitor'
// or null under the listen-first model.
export const categoryPill = {
  'Pain Point': 'bg-rose-50 text-rose-700 border border-rose-200',
  Competitor: 'bg-amber-50 text-amber-700 border border-amber-200',
  'Buying Signal': 'bg-green-50 text-green-700 border border-green-200',
};

// Hit-card badges (listen-first model).
export const hitBadge = {
  citebait: 'bg-indigo-50 text-indigo-700 border border-indigo-200',
  engage: 'bg-green-50 text-green-700 border border-green-200',
  duplicate: 'bg-gray-100 text-gray-500 border border-gray-200',
  net_new: 'bg-sky-50 text-sky-700 border border-sky-200',
};

// Keyword-filter check styling (kf_wants_this / kf_in_category / kf_path_to_surfox).
export const kfPass = 'text-green-600';
export const kfFail = 'text-rose-500';

export const statusPill = {
  active: 'bg-green-100 text-green-800',
  paused: 'bg-gray-100 text-gray-500',
};

// Per-platform badge colors for the Signal Feed (keyed lowercase).
export const platformPill = {
  reddit: 'bg-orange-50 text-orange-700 border border-orange-200',
  youtube: 'bg-red-50 text-red-700 border border-red-200',
};
export const platformPillDefault = 'bg-gray-100 text-gray-700 border border-gray-200';

// Common source platforms. Free text is still allowed in the Targets form.
export const PLATFORMS = ['Reddit', 'Facebook', 'X / Twitter', 'LinkedIn', 'Instagram', 'Forum', 'Other'];

export function relativeTime(ts) {
  if (!ts) return 'never';
  const diff = Date.now() - new Date(ts).getTime();
  const m = Math.floor(diff / 60000);
  const h = Math.floor(m / 60);
  const d = Math.floor(h / 24);
  if (m < 1) return 'just now';
  if (m < 60) return `${m}m ago`;
  if (h < 24) return `${h}h ago`;
  if (d < 7) return `${d}d ago`;
  return new Date(ts).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function fullTimestamp(ts) {
  if (!ts) return '—';
  return new Date(ts).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
